// pages links
export const navLinks = [
  { title: "Write", link: "/" },
  { title: "FAQ", link: "/?faq=true" },
  { title: "Account", link: "/account" },
];
